<template>
  <div class="w-4/5 mx-4 relative">
    <button @click="$router.go(-1)" class="my-4 py-2 px-4 bg-white text-black text-lg font-semibold rounded-lg shadow-md active:bg-white focus:outline-none">
      Back
    </button>
    <div class="bg-white p-4 rounded-md grid grid-cols-2 grid-flow-col gap-8">
      <div class="text-md font-medium">
        {{this.patient.identifier[0].value}} - {{this.patient.name[0].family}}, {{this.patient.name[0].given}}
      </div>
      <div>
        Survey Completed on: {{this.encounter.period.start}}
      </div>
    </div>
    <div class="my-4">
      <div class="grey lighten-5 divide-y divide-gray-500 bg-white p-4 rounded-md">
        <h1 class="mb-4 text-xl font-medium">{{ surveyTitle() }} Survey Responses</h1>
        <div v-if="!multipleSurveys()">
          <div v-for="(value, question) in survey.answer[0]" :key="question">
            <div class="grid grid-rows-2 grid-flow-row gap-1">
              <div class="max-w-full text-2xl text-gray-800 leading-8">
                {{ question }}
              </div>
              <div v-for="(answer, index) in question" :key="index" class="text-base text-gray-600 leading-7">
                {{ answer }}
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="multipleSurveys()" class="divide-y divide-gray-500">
          <div v-for="(item, index) in survey.answer" :key="index" class="mb-10 divide-y divide-gray-500">
            <h2 v-if="index === '1001'" class="text-lg font-medium my-2"><span class="text-red-500">*</span> Survey 1 Responses</h2>
            <h2 v-if="index === '1002'" class="text-lg font-medium my-2"><span class="text-red-500">*</span> Survey 2 Responses</h2>
            <div class="grid grid-flow-row gap-2 divide-y divide-gray-500">
            <div v-for="(subquestion, index1) in item" :key="index1">
              <!-- subquestion is {{ subquestion }} and index is {{index}} -->
                <div v-for="(answer, index2) in subquestion" :key="index2" class="text-base text-gray-600 leading-7 mt-2">
                  <p class="float-left"><span v-if="index2 === 'displayUrl' || index2 === 'display'">{{ index1 }} : </span><span v-if="index2 === 'value'" class="text-gray-800">{{ answer }}</span></p>
                  <p v-if="index2 !== 'imgHeight' && index2 !== 'imgWidth' && index2 !== 'imgType' && index2 !== 'displayUrl' && index2 !== 'value' && index2 !== 'display'">{{index2}} : <span class="text-gray-800">{{ answer }}</span></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navigation from '@/components/Navigation.vue'

export default {
  data () {
    return {
      // crumbs: [
      //   { text: 'Patients', disabled: false, href: '/' },
      //   { text: 'Encounter-10001', disabled: false, href: `#` },
      //   { text: 'Survey-VR12', disabled: true, href: `#` }
      // ],
      encounter: [],
      patient: {},
      survey: {}
    }
  },
  components: {
    Navigation
  },
  methods: {
    multipleSurveys() {
      // loop through survey answer objects
      for (let i in this.survey.answer) {
        // if multiple surveys
        if (i > 1) {
          return true
        }
        // if one survey
        else {
          return false
        }
      }
    },
    surveyTitle() {
      if (this.survey.questionnaire === '10002') return 'OAHKS Experience'
      else if (this.survey.questionnaire === '102') return 'OAHKS WOMAC'
      else if (this.survey.questionnaire === '101') return 'VR-12'
      else if (this.survey.questionnaire === '104') return 'OAHKS Pre Visit'
    }
  },
  async created () {
    if (this.$route.params.responseId !== null) {
      const encounterResults = await this.axios.get(`${process.env.VUE_APP_API_BASEURL}/encounter/${this.$route.params.encounterId}`)
      this.encounter = encounterResults.data
      const patientResults = await this.axios.get(`${process.env.VUE_APP_API_BASEURL}/patient/${this.$route.params.patientId}`)
      this.patient = patientResults.data
      const results = await this.axios.get(`${process.env.VUE_APP_API_BASEURL}/survey/${this.$route.params.responseId}`)
      this.survey = results.data
    }
  }
}
</script>